<template>
  <div>
    <div class="subtitle-1 mt-4">{{ $t('tenants.sso_domains') }}</div>
    <div class="caption mb-2">{{ $t('tenants.sso_domains_help') }}</div>

    <v-list dense class="py-0">
      <v-list-item v-for="item in domains" :key="item.id" class="px-0">
        <v-list-item-content>
          <v-list-item-title>{{ item.domain }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon small :loading="removingId === item.id" @click="removeDomain(item)">
            <v-icon small>mdi mdi-delete</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <div class="d-flex align-center">
      <v-text-field v-model="newDomain" :label="$t('tenants.sso_domain')" hide-details dense @keyup.enter="addDomain" />
      <v-btn text color="primary" class="ml-2" :disabled="!newDomain" :loading="adding" @click="addDomain">{{ $t('add') }}</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TenantDomains',
  props: {
    tenantId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      domains: [],
      newDomain: '',
      adding: false,
      removingId: null,
    };
  },
  watch: {
    tenantId: {
      immediate: true,
      handler() {
        this.loadDomains();
      },
    },
  },
  methods: {
    async loadDomains() {
      this.domains = await this.$adminApi.getTenantDomains(this.tenantId);
    },
    async addDomain() {
      this.adding = true;
      try {
        await this.$adminApi.addTenantDomain(this.tenantId, this.newDomain);
        this.newDomain = '';
        await this.loadDomains();
      } catch (err) {
        this.$handleApiError(err, this.$t('tenants.sso_domain_add_failed'));
      }
      this.adding = false;
    },
    async removeDomain(item) {
      this.removingId = item.id;
      try {
        await this.$adminApi.removeTenantDomain(this.tenantId, item.id);
        await this.loadDomains();
      } catch (err) {
        this.$handleApiError(err, this.$t('tenants.sso_domain_remove_failed'));
      }
      this.removingId = null;
    },
  },
};
</script>
